import { render, staticRenderFns } from "./ShipmentInfo.vue?vue&type=template&id=2e17bb9e&scoped=true&"
import script from "./ShipmentInfo.vue?vue&type=script&lang=js&"
export * from "./ShipmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentInfo.vue?vue&type=style&index=0&id=2e17bb9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e17bb9e",
  null
  
)

export default component.exports